import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "account-section" }
const _hoisted_2 = { class: "account-avatar" }
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 1,
  class: "bi bi-person-circle"
}
const _hoisted_5 = { class: "account-name font-Baloo-Regular" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      class: "account-button",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goToAccountPage && _ctx.goToAccountPage(...args))),
      "data-bs-dismiss": "offcanvas",
      "data-bs-target": "#offcanvas"
    }, [
      _createElementVNode("div", _hoisted_2, [
        (_ctx.userAvatar)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: require(`@/assets/images/avatar/${_ctx.userAvatar}`),
              alt: "User Avatar",
              class: "avatar-img"
            }, null, 8, _hoisted_3))
          : (_openBlock(), _createElementBlock("i", _hoisted_4))
      ]),
      _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.displayName), 1)
    ])
  ]))
}